<template>
	<div class="addLabelCategoryDialog publicDialogTop addSpecialDialog">
		<el-dialog
			:title="title"
			:visible.sync="dialog"
			:modal-append-to-body="false"
		>
			<div class="folder">
				<el-form
					label-position="right"
					label-width="120px"
					:model="formData"
					:rules="rule"
					ref="formData"
				>
					<el-form-item label="专区名称：" prop="name">
						<el-input
							v-model="formData.name"
							class="custom_input_350"
						></el-input>
					</el-form-item>
					<el-form-item label="选择父级：" prop="pid">
						<!-- <el-select v-model="formData.pid" placeholder="请选择父级">
							<el-option
								:label="item.name"
								:value="item.id"
								v-for="(item, index) in tableData"
								:key="index"
							>
							</el-option>
						</el-select> -->

						<el-radio
							v-model="formData.pid"
							:label="item.id"
							v-for="(item, index) in tableData"
							:key="index"
						>
							{{ item.name }}
						</el-radio>
					</el-form-item>
					<el-form-item label="专区图片：" prop="pic">
						<img
							style="width: 80%"
							v-if="formData.pic"
							:src="formData.pic"
							@click="uploadPicture(formData.pic)"
						/>
						<div v-else>
							<div class="el-upload__text" @click="uploadPicture(formData.pic)">
								<img
									style="width: 100px"
									src="../../../assets/images/uploadImg.png"
									alt=""
								/>
								<br /><em>点击加号上传</em></div
							>
						</div>
						<!-- 剪裁组件弹窗 -->
						<el-dialog
							title="裁切封面"
							:visible.sync="cropperModel"
							width="950px"
							center
							:append-to-body="true"
						>
							<cropper-image
								:Name="cropperName"
								@uploadImgSuccess="handleUploadSuccess"
								ref="child"
							>
							</cropper-image>
						</el-dialog>
					</el-form-item>
					<el-form-item label="专区描述：" prop="desc">
						<el-input
							v-model="formData.desc"
							class="custom_input_350"
						></el-input>
					</el-form-item>
					<el-form-item label="是否精选：">
						<el-radio v-model="formData.is_selected" label="1">是</el-radio>
						<el-radio v-model="formData.is_selected" label="0">否</el-radio>
					</el-form-item>
					<el-form-item label="语言：" prop="language">
						<el-select v-model="formData.language" placeholder="请选择语言">
							<el-option label="简体中文" value="1"> </el-option>
							<el-option label="英语" value="2"> </el-option>
							<!-- <el-option label="日语" value="3">
                            </el-option>
                            <el-option label="繁体中文" value="4">
                            </el-option> -->
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" class="saveBtn" @click="submit('formData')"
					>新增/修改</el-button
				>
				<el-button @click="dialog = false" class="cancel">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { validateNull } from "@/utils/validate";
import { addspecial, updatespecial } from "@/api/article";
import { uploadImage } from "@/api/user";
export default {
	name: "",
	props: ["title", "type", "tableData"],
	data() {
		return {
			rule: {
				name: [{ validator: validateNull, trigger: "blur", required: true }],
				desc: [{ validator: validateNull, trigger: "blur", required: true }],
				language: [
					{ validator: validateNull, trigger: "change", required: true },
				],
			},
			dialog: false, //文件夹弹框
			formData: {
				pid: "",
				name: "",
				pic: "",
				desc: "",
				is_selected: "1",
				language: "",
			},
			//参数
			cropperModel: false,
			cropperName: "",
		};
	},
	methods: {
		//封面设置
		uploadPicture(name) {
			if (this.$route.query.type == "detail") {
				// 详情不支持编辑图片
			} else {
				this.cropperName = name;
				this.cropperModel = true;
			}
		},
		//图片上传成功后
		handleUploadSuccess(data) {
			console.log(data.url);
			this.cropperModel = false;
			this.formData.pic = data.url;
		},
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const that = this;
					console.log("this.type", this.type);
					if (that.type == "add") {
						addspecial(that.formData)
							.then((res) => {
								if (res.code == 200) {
									that.dialog = false;
									if (that.type == "edit") {
										that.$parent.$parent.$parent.getDataList();
									} else {
										that.$parent.getDataList();
									}
								} else {
								}
							})
							.catch((error) => {});
					} else {
						updatespecial(that.formData)
							.then((res) => {
								if (res.code == 200) {
									that.dialog = false;
									if (that.type == "edit") {
										that.$parent.$parent.$parent.getDataList();
									} else {
										that.$parent.getDataList();
									}
								} else {
								}
							})
							.catch((error) => {});
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		clearFormAdd() {
			for (let key in this.formData) {
				this.formData[key] = "";
			}
		},
	},
};
</script>

<style scoped>
.folder {
	margin-top: 25px;
}

.folder .el-input {
	width: 532px;
	background: #ffffff;
	opacity: 1;
	font-size: 16px;
	font-family: Source Han Sans CN-Regular, Source Han Sans CN;
	font-weight: 400;
	color: #666666;
}

.folder .el-textarea {
	width: 532px;
	background: #ffffff;
	opacity: 1;
}

.saveBtn {
	width: 200px;
	height: 48px;
	background: #5681ff;
	border-radius: 6px 6px 6px 6px;
	opacity: 1;
	font-size: 22px;
	font-family: Source Han Sans CN-Regular, Source Han Sans CN;
	font-weight: 400;
	color: #ffffff;
}

.cancel {
	width: 200px;
	height: 48px;
	background: #ffffff;
	border-radius: 6px 6px 6px 6px;
	opacity: 1;
	border: 1px solid #999999;
	margin-left: 80px;
	font-size: 22px;
	font-family: Source Han Sans CN-Regular, Source Han Sans CN;
	font-weight: 400;
	color: #999999;
}
</style>
<style>
.addSpecialDialog .el-dialog {
	width: 700px;
	background: #ffffff;
	box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.29);
	border-radius: 10px 10px 10px 10px;
	opacity: 1;
	display: block !important;
	text-align: left;
}

.addLabelCategoryDialog .el-dialog__title {
	font-size: 20px;
	font-family: Source Han Sans CN-Bold, Source Han Sans CN;
	font-weight: bold;
	color: #222222;
	margin-left: 30px;
}

.addLabelCategoryDialog .el-dialog__close::before {
	font-size: 18px;
	color: #000;
}

.addLabelCategoryDialog .el-dialog__header {
	border-radius: 10px 10px 0px 0px;
	padding: 0;
	width: 100%;
	height: 71px;
	display: flex;
	align-items: center;
	border: 1px solid #e0e0e0;
}

.addLabelCategoryDialog .el-dialog__headerbtn {
	top: initial;
	right: 40px;
}

.addLabelCategoryDialog .el-dialog__footer {
	padding: 0;
	display: flex;
	justify-content: center;
	padding-bottom: 40px;
}

.addSpecialDialog .el-dialog__body {
	padding: 0 0px;
}
</style>
